import $ from "jquery";

/**
 * This class provides the ability to log various user activities across the site
 */
class ActivityHelper {
    constructor() {
    }

    /**
     * Activity Logging for blog page views
     * @param blogPostNodeGuid  Node Guid as Param and Posts it to API as Object along with isPreviewEnabled flag                                                        
     */
    logBlogPostPageView(blogPostNodeGuid) {
        var blogPageActivity = {};

        blogPageActivity.NodeGuid = blogPostNodeGuid;
        blogPageActivity.IsPreviewPage = window.shm.isPreviewEnabled;
        $.ajax({
            type: "POST",
            url: "/blogpost/logblogpageactivity",
            dataType: 'json',
            data: JSON.stringify(blogPageActivity),
            contentType: 'application/json',
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                console.log(data)
            }
        });
    }

    trackPageVisit(documentId, pageTypeName) {
        var dataObject = {
            pageTypeName: pageTypeName,
            documentID: documentId
        };
        $.ajax({
            type: 'POST',
            url: '/pagevisitmshuser/trackPagevisit',
            data: JSON.stringify(dataObject),
            dataType: 'json',
            contentType: 'application/json',
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                console.log(data)
            },
        });
    }
}

export { ActivityHelper as default }